import { Button, ButtonStyles } from '@silverfort/sf-components';

const CreateApplicationFooter = ({ onCancel, onSave, isLoading, saveText }) => {
    return (
        <div className="fixed right-0 bottom-0 left-0 border-t border-gray-100 bg-white h-14">
            <div className="flex justify-end px-6 py-2 space-x-2 items-center">
                <Button text="Cancel" onClick={onCancel} buttonStyle={ButtonStyles.GhostSolid} disabled={isLoading} />
                <Button text={saveText} onClick={onSave} buttonStyle={ButtonStyles.PrimarySolid} disabled={isLoading} />
            </div>
        </div>
    );
};

export default CreateApplicationFooter;
